<template>
  <div>
    <div align="left">
      <el-button type="primary" icon="el-icon-circle-plus" @click="showDialog" >增加新的车辆</el-button>
    </div>


    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="100%">
      <el-table-column
        fixed
        prop="id"
        label="编号"
        width="100">
      </el-table-column>
      <el-table-column
        prop="car_id"
        label="车牌号"
        width="100">
      </el-table-column>

      <el-table-column
        prop="remarks"
        label="备注"
        width="150">
      </el-table-column>
      <el-table-column
        prop="creator"
        label="创建者"
        width="180">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间"
        width="140">
      </el-table-column>
      <el-table-column
        prop="modifier"
        label="修改者"
        width="130">
      </el-table-column>
      <el-table-column
        prop="modify_time"
        label="修改时间"
        width="300">
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="220">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="changeEnable(scope.$index, tableData)"
            size="mini" :type="tableData[scope.$index].state&1==1?'danger':'success'" >
            {{tableData[scope.$index].state&1==1?"停用":"启用"}}
          </el-button>

        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10,20,50,100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog title="增加新的车辆" :visible.sync="dialogFormVisible">
      <el-form :model="form" align="left">

        <!--<el-form-item label="职能" :label-width="formLabelWidth">-->
        <!--<el-select v-model="form.role" placeholder="请选择用户职能">-->
        <!--<el-option label="管理员(可登陆后台查看信息)" value="管理员"></el-option>-->
        <!--<el-option label="投放员(可登陆投放终端进行医废投放)" value="投放员"></el-option>-->
        <!--</el-select>-->
        <!--</el-form-item>-->
        <el-form-item label="车牌号" :label-width="formLabelWidth">
          <el-input v-model="form.car_id" autocomplete="on" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth">
          <el-input v-model="form.remarks" autocomplete="off"  clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createCar">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
  import coder from "./enum.js"
  export default {
    methods: {
      showDialog(e){
        this.form={
          car_id:'',
          remarks:'',
        };
        this.dialogFormVisible=true;
      },

      createCar(){
        console.log("createCar:",this.form);
        if (this.form.car_id==""){
          this.$alert('请输入车牌号', '错误', {
            confirmButtonText: '确定'
          });
          return
        }

        let $this=this;
        window.ws.AddFunc("S2W_CreateCarRes",function (code,err,info) {
          console.log(code,coder.OK,code==coder.OK);
          if (Number(code)!==coder.OK){
            $this.$alert(err+'('+code+')', '错误', {
              confirmButtonText: '确定'
            });
          }else {
            //console.log(code, err, info);
            $this.$notify({
              title: '成功',
              message: '添加车辆成功',
              type: 'success'
            });
            $this.dialogFormVisible=false;
            window.ws.Call("W2S_CarList",$this.page,$this.pageSize);
          }

        });
        window.ws.Call("W2S_CreateCar",this.form.car_id,this.form.remarks)
      },
      changeEnable(index, rows) {
        console.log("changeEnable:",index);
        if (rows[index].state&1==1){
          rows[index].state^=1
        }else{
          rows[index].state|=1
        }
      },
      handleSizeChange(e){
        this.pageSize=e;
        window.ws.Call("W2S_CarList",this.page,this.pageSize);
      },
      handleCurrentChange(e){
        this.page=e;
        window.ws.Call("W2S_CarList",this.page,this.pageSize);
      }
    },
    mounted() {
      let $this=this;
      console.log("###Page loaded !");
      window.ws.AddFunc("S2W_CarListRes",function (code,err,currentPage,total,list) {
        console.log("S2W_CarListRes:",code,err,currentPage,total,list)
        if (code==coder.OK){
          $this.page=currentPage;
          $this.total=total;
          $this.tableData=list;
        }
      });
      window.ws.Call("W2S_CarList",$this.page,$this.pageSize);
    },
    data() {
      return {
        form: {
          car_id:'',
          remarks:'',
        },
        dialogFormVisible:false,
        formLabelWidth: '120px',
        page:1,
        pageSize:10,
        total:0,
        tableData: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/carList.vue